document.addEventListener("DOMContentLoaded", function () {
  const sizeChartLink = document.getElementById("sizeChart");
  const howToMeasureLink = document.getElementById("measure");
  const categoryModal = document.getElementById("categoryModal");
  const measureModal = document.getElementById("MeasureModal");

  sizeChartLink.addEventListener("click", function (event) {
    event.preventDefault();
    categoryModal.classList.remove("size-guide-hidden-modal-body");
    measureModal.classList.add("size-guide-hidden-modal-body");
    sizeChartLink.classList.add("size-guide-selected-modal-menu");
    howToMeasureLink.classList.remove("size-guide-selected-modal-menu");
  });

  howToMeasureLink.addEventListener("click", function (event) {
    event.preventDefault();
    measureModal.classList.remove("size-guide-hidden-modal-body");
    categoryModal.classList.add("size-guide-hidden-modal-body");
    howToMeasureLink.classList.add("size-guide-selected-modal-menu");
    sizeChartLink.classList.remove("size-guide-selected-modal-menu");
  });
});
